import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { ModalController, PopoverController, IonicModule } from '@ionic/angular';
import type { ModalOptions } from '@ionic/angular';
import { timer } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// import type { PopoverOptions } from '@ionic/core';
// import { CallNumber } from 'capacitor-call-number';
// import { CallNumber } from '@ionic-native/call-number/ngx';
// import { Insomnia } from '@ionic-native/insomnia/ngx';

import { TicketsModalPage } from '../ticketsModal/ticketsModal.page';
import { ViewBasePage } from '../viewBase/viewBase.page';
import {
    CapacitorService, EventsService, FirebaseFunctionsService, LocalDataService, UtilsService, TripsService,
    RoutesService, ShuttlesService, ShuttleMovementService, TicketsService
} from '@shared/services';

// import {
//     RoutesService, ShuttlesService, ShuttleMovementService, TicketsService
// } from '@shared/services';
// import {
// } from '@shared/services';

import type { TTicket, TCustomer, TNavigationViewModel, TResponse } from '@shared/models';


@Component({
    'selector': 'app-navigationBasePage',
    'templateUrl': './navigationBase.page.html',
    'styleUrls': ['./navigationBase.page.scss'],
    'standalone': true,
    // imports: [PopoverController, ModalController, IonicModule]
    imports: [IonicModule, CommonModule, FormsModule]   

})
export class NavigationBasePage extends ViewBasePage implements OnInit, OnDestroy {
    // protected vm: TNavigationViewModel;
    // protected override popoverController: PopoverController;
    // protected override modalController: ModalController;
    // protected override utilsService: UtilsService;
    // protected override eventsService: EventsService;
    protected ticketsService: TicketsService;
    protected tripsService: TripsService;
    protected shuttlesService: ShuttlesService;
    protected shuttleMovementService: ShuttleMovementService;
    protected routesService: RoutesService;
    // protected firebaseFunctionsService: FirebaseFunctionsService;
    protected capacitorService: CapacitorService;
    // protected insomnia: Insomnia;
    // private callNumber: CallNumber;
    private navigationMenuItems: string[] = [];

    // private localDataService: LocalDataService;

    constructor(injector: Injector) {
        super(injector);
        this.modalController = injector.get(ModalController);
        this.popoverController = injector.get(PopoverController);
        this.localDataService = injector.get(LocalDataService);
        this.ticketsService = injector.get(TicketsService);
        this.tripsService = injector.get(TripsService);
        this.shuttlesService = injector.get(ShuttlesService);
        // this.callNumber = injector.get(CallNumber);
        this.utilsService = injector.get(UtilsService);
        this.shuttleMovementService = injector.get(ShuttleMovementService);
        this.firebaseFunctionsService = injector.get(FirebaseFunctionsService);
        this.routesService = injector.get(RoutesService);
        this.eventsService = injector.get(EventsService);
        this.capacitorService = injector.get(CapacitorService);
        // this.insomnia = injector.get(Insomnia);
        // this.callNumber = new CallNumber();

        // this.eventsService.subscribe(Constants.EVENT_NAV_MORE_MENU_CHANGE, () => { this.onMoreMenuChangeEvent(); });
    }

    public override ngOnInit(): void {
        super.ngOnInit();
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    protected async keepAwake() {
        const isDevice = this.sessionService.getIsMobileDevice();
        // console.log('isDevice', isDevice.toString());
        // await this.insomnia.keepAwake();


        // this.insomnia.keepAwake()
        // .then(
        //     () => console.log('Insomnia Notification', 'keepAwake success'),
        //     () => console.log('Insomnia Notification', 'keepAwake error')
        // );
    }

    public isDebugMode(): boolean {
        return this.sessionService.isDebugMode();
    }

    protected async allowSleepAgain() {
        // await this.insomnia.allowSleepAgain()

        // this.insomnia.allowSleepAgain()
        // .then(
        //     () => console.log('Insomnia Notification', 'allowSleepAgain success'),
        //     () => console.log('Insomnia Notification', 'allowSleepAgain error')
        // );
    }

    protected supplyDebugMenuItems(): void {
        // if (this.sessionService.isDebugMode()) {
        if (this.sessionService.isDebugMode()) {
            this.pushPopoverMenuItem('Send Pickup Request');
            this.pushPopoverMenuItem('Send Pickup Shuttle Arrived Text');
            // this.pushPopoverMenuItem('Move Shuttle 1 Mile');
            this.pushPopoverMenuItem('Test Firebase Function');
            this.pushPopoverMenuItem('Call Me');
        }
    }

    protected async handleMenuItemClick(menuItem: any, vm: TNavigationViewModel): Promise<void> {
        // case 'Call Current Passenger':
        //     this.callCurrentPassenger();
        //     break;
        // case 'Move Shuttle 1 Mile':
        //     this.debugMoveShuttle1Mile();
        //     break;

        switch (menuItem.name) {
            case 'Show Tickets':
                this.showTickets(vm);
                break;

            case 'Send Pickup Shuttle Arrived Text':
                this.sendPickupShuttleArrivedText(vm);
                break;

            case 'Send Pickup Request':
                this.debugNavigationPickupRequest();
                break;


            case 'Test Firebase Function':
                this.testFirebaseFunction();
                break;

            case 'Call Me':
                this.callMe();
                break;
        }
    }

    protected onMoreMenuChangeEvent(): void {
        // // this.vm = vm;
        // this.navigationMenuItems = [];
        // let addShowTicketsToMenu = false;
        // let addCallCurrentPassengerToMenu = false;
        // let addSendPickupShuttleArrivedTextToMenu = false;

        // switch (this.pageName) {
        //     case this.Constants.VIEW_NAVIGATION_PAGE1:
        //         break;

        //     case this.Constants.VIEW_NAVIGATION_PAGE2:
        //         addShowTicketsToMenu = true;
        //         break;

        //     case this.Constants.VIEW_NAVIGATION_PAGE3:
        //         addShowTicketsToMenu = true;
        //         break;

        //     case this.Constants.VIEW_NAVIGATION_PAGE4:
        //         addShowTicketsToMenu = true;
        //         if (this.vm.currentLeg) {
        //             addCallCurrentPassengerToMenu = true;
        //             addSendPickupShuttleArrivedTextToMenu = true;
        //         }
        //         break;

        //     case this.Constants.VIEW_NAVIGATION_PAGE5:
        //         // addShowTicketsToMenu = true;
        //         break;
        // }

        // if (addShowTicketsToMenu) {
        //     // if (!this.navigationMenuItems.includes('Show Tickets')) {
        //         this.navigationMenuItems.push('Show Tickets');
        //     // }
        // }
        // if (addCallCurrentPassengerToMenu) {
        //     // if (!this.navigationMenuItems.includes('Call Current Passenger')) {
        //         this.navigationMenuItems.push('Call Current Passenger');
        //     // }
        // }
        // if (addSendPickupShuttleArrivedTextToMenu) {
        //     // if (!this.navigationMenuItems.includes('Send Pickup Shuttle Arrived Text')) {
        //         this.navigationMenuItems.push('Send Pickup Shuttle Arrived Text');
        //     // }
        // }    

        // // this.navigationMenuItems = ['Show Tickets', 'Call Current Passenger', 'Send Pickup Shuttle Arrived Text'];
        // if (this.sessionService.isDebugMode()) {
        //     this.navigationMenuItems.push('Debug Navigation Pickup Request');
        //     this.navigationMenuItems.push('Debug Move Shuttle 1 Mile');
        //     this.navigationMenuItems.push('Debug Send All Text Messages');
        // }
    }

    protected getModalController(): ModalController {
        return this.modalController;
    }

    protected recalculateTicketStatuses(vm: TNavigationViewModel) {
        // this.vm.assignedTickets = this.vm.tickets.filter((ticket: TTicket) => ticket.status === 'assigned');
        // this.vm.enrouteTickets = this.vm.tickets.filter((ticket: TTicket) => ticket.status === 'enroute');
        // this.vm.currentTickets = this.vm.tickets.filter((ticket: TTicket) => ticket.status === 'current');
        // this.vm.completedTickets = this.vm.tickets.filter((ticket: TTicket) => ticket.status === 'completed');

        vm.assignedTickets = vm.tickets.filter((ticket: TTicket) => ticket.status === 'assigned');
        vm.enrouteTickets = vm.tickets.filter((ticket: TTicket) => ticket.status === 'enroute');
        vm.currentTickets = vm.tickets.filter((ticket: TTicket) => ticket.status === 'current');
        vm.completedTickets = vm.tickets.filter((ticket: TTicket) => ticket.status === 'completed');
    }

    // public async onMoreClick(event) {
    //     const options: PopoverOptions = {
    //         'component': PopoverMenu,
    //         'componentProps': { 'menuItems': this.navigationMenuItems },
    //         'event': event,
    //         'showBackdrop': true,
    //         'cssClass': 'myNavigationMoreMenuClass'
    //     };

    //     const popover = await this.popoverController.create(options);
    //     popover.onDidDismiss()
    //     .then((response: any) => {
    //         if (response.data) {
    //             switch (response.data.selectedItem) {
    //                 case 'Show Tickets':
    //                     this.showTickets();
    //                     break;

    //                 case 'Call Current Passenger':
    //                     this.callCurrentPassenger();
    //                     break;

    //                 case 'Send Pickup Shuttle Arrived Text':
    //                     this.sendPickupShuttleArrivedText();
    //                     break;

    //                 case 'Debug Navigation Pickup Request':
    //                     this.debugNavigationPickupRequest();
    //                     break;

    //                 case 'Debug Move Shuttle 1 Mile':
    //                     this.debugMoveShuttle1Mile();
    //                     break;

    //                 case 'Debug Send All Text Messages':
    //                     this.debugSendAllTextMessages();
    //                     break;
    //                 // case 'Load Local Data':
    //                 //     this.loadDummyData();
    //                 //     break;
    //             }
    //         }
    //     });
    //     popover.present();
    // }

    private async showTickets(vm: TNavigationViewModel): Promise<void> {
        if (!vm.tickets) {
            this.uxHelperService.showAlert('Alert', 'No tickets are defined for this shuttle.  Try selecting a different shuttle.');
            return;
        }

        // The call to this routine doesn't really belong here.
        // It should be updated everytime the status of the ticket changes.
        // However, the only time we need these scoped values is now.
        this.recalculateTicketStatuses(vm);

        const options: ModalOptions = {
            'component': TicketsModalPage,
            'componentProps': { 'vm': vm },
            'backdropDismiss': true,
            'showBackdrop': true,
            'cssClass': 'myModalSize'
        };

        const myModal = await this.modalController.create(options);
        myModal.present();
        myModal.onDidDismiss();
    }

    private async sendPickupShuttleArrivedText(vm: TNavigationViewModel) {
        if (vm.currentTicket === undefined) {
            this.uxHelperService.showAlert('Can\'t Send Text', 'Pickup Shuttle Arrived.');
            return;
        }

        const msg = 'Are you sure you want to send the shuttle arrived text message?';
        const response = await this.uxHelperService.showAlert('Confirm Send Message', msg);
        if (response.okay) {
            const customer: TCustomer = {
                'customerName': vm.currentTicket.passengerName,
                'cellPhone': vm.currentTicket.cellPhone,
                'uid': '',
                'cellPhoneStr': '',
                'countryCode': '',
                'maskedCellPhone': '',
                'createdDate': this.dateService.getMaximumDate(),
                'isShuttlePassenger': false,
                'shuttleDates': [],
                'isActive': true,
                'checked': false,
                'selected': false,
                'sessionId': 0,
                'disabled': false
            };
            const customers: TCustomer[] = [customer];

            const tocoordinate = vm.currentLeg.to.location.address.coordinate;
            const data = { 'customers': customers, 'tocoordinate': tocoordinate };
            this.eventsService.publish(this.Constants.EVENT_PICKUP_ARRIVED, data.toString());
        }
    }

    private debugNavigationPickupRequest() {
        // this.ticketsService.debugAddPickupRequest();
    }

    // private async debugMoveShuttle1Mile() {
    //     const vector = this.vm.myVector;
    //     if (!vector) {
    //         this.uxHelperService.showAlert('Error', 'The route has not been started.');
    //         return;
    //     }

    //     await this.uxHelperService.showSpinner();
    //     await this.shuttleMovementService.moveShuttle1Mile(vector);
    //     await this.uxHelperService.hideSpinner();
    // }

    private async testFirebaseFunction() {
        // const data: any = {};
        // const customer: TCustomer = {
        //     'customerName': 'Michael Carr',
        //     'cellPhone': '6618778631',
        //     'uid': ''
        // };

        // this.eventsService.publish(this.Constants.EVENT_TRACK_USAGE, {'viewname': this.Constants.VIEW_ROUTES});

        // this.firebaseFunctionsService.convertStreetAddressToLatLng('1690 Danbury Crossing Dr. Nevada, 89052');
        // this.firebaseFunctionsService.callGetMetaDataByEmail();

        // await this.firebaseFunctionsService.addAccountToTOC('22287-1146-21564');
        await this.firebaseFunctionsService.testFirebaseFunction();

        // this.publishEvent(this.Constants.EVENT_TRACK_USAGE, {'viewname': this.Constants.VIEW_ROUTES});
        // data = { customers: [customer], 'debug': { 'eventName': 'ticketCreated', 'num': 1} };
        // data = { customers: [customer] };
        // this.publishEvent(this.Constants.EVENT_TICKET_CREATED, data);

        // data = { 'customers': [customer], 'debug': { 'eventName': 'allAboard', 'num': 2} };
        // this.publishEvent(this.Constants.EVENT_ALL_ABOARD, data);

        // data = { customers: [customer], 'debug': { 'eventName': 'dropoffApproaching', 'num': 3} };
        // this.publishEvent(this.Constants.EVENT_APPROACHING_DROPOFF, data);

        // data = { customers: [customer], 'debug': { 'eventName': 'dropoffCompleted', 'num': 4} };
        // this.publishEvent(this.Constants.EVENT_DROPOFF_COMPLETED, data);

        // data = { customers: [customer], 'debug': { 'eventName': 'pickupApproaching', 'num': 5} };
        // this.publishEvent(this.Constants.EVENT_APPROACHING_PICKUP, data);

        // data = { customers: [customer], 'debug': { 'eventName': 'pickupArrived', 'num': 6} };
        // this.publishEvent(this.Constants.EVENT_PICKUP_ARRIVED, data);

        // data = { customers: [customer], 'debug': { 'eventName': 'pickupCompleted', 'num': 7} };
        // this.publishEvent(this.Constants.EVENT_PICKUP_COMPLETED, data);

        // data = { customers: [customer], 'debug': { 'eventName': 'campaign', 'num': 8} };
        // this.publishEvent(this.Constants.EVENT_CAMPAIGN_MESSAGE, data);

        // 

        // Add ActiveCampaign tags to a customer
        // const email1 = 'benf@gmail.com';
        // const tagsToAdd: string[] = ['ONBOARDING:settings'];
        // const tagsToDelete: string[] = [];
        // this.firebaseFunctionsService.adjustActiveCampaignTags(email1, tagsToAdd, tagsToDelete);

        // // Delete an ActiveCampaign tag from a customer
        // const email2 = 'Michael@ShuttleNomix.com';
        // const tagsToDelete: string[] = ['shuttle'];
        // this.firebaseFunctionsService.adjustActiveCampaignTags(email2, [], tagsToDelete);
    }

    private publishEvent(eventName: string, data: any): void {
        try {
            this.eventsService.publish(eventName, data);
            timer(1000);
        } catch (err) {
            // console.error(err);
        }
    }

    private callMe() {
        try {
            const me = this.sessionService.getCurrentUser();
            const fullname = `${me.firstName} ${me.lastName}`;
            this.capacitorService.callPrompt(me.cellPhone, fullname);
        } catch (err) {
            // console.log('CallMe error: ' + err);
        }
    }

    // private callCurrentPassenger() {
    //     try {
    //         const fullname = this.vm.currentTicket.passengerName;
    //         const cellPhone = this.vm.currentTicket.cellPhone;

    //         this.capacitorService.callPrompt(cellPhone, fullname);
    //     } catch (err) {
    //         console.log('CallMe error: ' + err);
    //     }
    // }

    // private loadDummyData() {
    //     this.localDataService.readFile(this.Constants.FILENAME_DUMMY_DATA);
    // .then((data) => {
    //     let trips = this.localDataService.getTrips();
    //     let tickets = this.localDataService.getTickets();
    //     let acceptanceTicket = this.localDataService.getNavigationAcceptanceTicket();

    //     if (tickets.length > 0) {
    //         tickets.forEach((ticket) => {
    //             this.ticketsService.pushChild(ticket);
    //         });
    //     }

    //     if (acceptanceTicket !== undefined) {
    //         this.ticketsService.pushChild(acceptanceTicket);
    //     }

    //     if (trips.length > 0) {
    //         trips.forEach((trip) => {
    //             this.tripsService.pushChild(trip);
    //         });
    //     }

    //     let msg = tickets.length + ' tickets added. ' +
    //               trips.length + ' trips added. ' +
    //               (acceptanceTicket === undefined ? 0 : 1) + ' acceptance tickets added.';
    //     this.uxHelperService.showToast(msg);
    // });
    // }
}
